import { render, staticRenderFns } from "./NotificationSubscriptionPurchase.vue?vue&type=template&id=5f070a0a&scoped=true&"
import script from "./NotificationSubscriptionPurchase.vue?vue&type=script&lang=ts&"
export * from "./NotificationSubscriptionPurchase.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationSubscriptionPurchase.vue?vue&type=style&index=0&id=5f070a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f070a0a",
  null
  
)

export default component.exports